const cuisineReducer = (state = [], {type, cuisines}) => {
    switch(type) {
        case 'SET_CUISINES':
            return cuisines;
        default:
            return state;
    }
}

export default cuisineReducer;